import { createFileRoute, redirect } from "@tanstack/react-router"
import { INVENTORY_ANALYSIS_PRESET_GROUP_ID } from "~/pages/sales-operations/inventory-overview/InventoryAnalysis"

// Legacy URL — the Calendar view is now a preset of /insights/inventory-overview.
// Seed the active preset (session storage) so old bookmarks land on the Calendar preset.
export const Route = createFileRoute("/_auth/insights/inventory-overview/_layout/calendar")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(
        `${INVENTORY_ANALYSIS_PRESET_GROUP_ID}-preset-id`,
        JSON.stringify("calendar"),
      )
    }
    throw redirect({ to: "/insights/inventory-overview" })
  },
})
